import type { MembershipBillingOption } from '@/components/organisms/pricebook/support/membership-plan-shared';

/**
 * A free billing option is the office's to give, never the customer's to
 * pick: a $0 base over a fixed term, with extra units and the setup fee still
 * billed. Mirrors Operations' `complimentary-billing-option.ts`.
 */
export function isComplimentaryBillingOption(
  option: Pick<MembershipBillingOption, 'isComplimentary'> | null | undefined,
): boolean {
  return option?.isComplimentary === true;
}

/** Was this membership sold on a free, office-only option? Reads the sold snapshot. */
export function soldOnComplimentaryOption(planSnapshot: unknown): boolean {
  if (!planSnapshot || typeof planSnapshot !== 'object') return false;
  const selected = (planSnapshot as { selectedBillingOption?: unknown }).selectedBillingOption;
  return (
    Boolean(selected) &&
    typeof selected === 'object' &&
    (selected as { isComplimentary?: unknown }).isComplimentary === true
  );
}

/** The label the office sees on a free option wherever options are listed. */
export const COMPLIMENTARY_OPTION_LABEL = 'Free · office only';
